import React from 'react'
import Style from '../summaryDetails.module.css'
const PAGE_SIZES = [10, 25, 50]
const pageWindow = (page, pageCount) => {
    const pages = []
    for (let p = 1; p <= pageCount; p++) {
        if (p === 1 || p === pageCount || Math.abs(p - page) <= 1) {
            pages.push(p)
        } else if (pages[pages.length - 1] !== null) {
            pages.push(null)
        }
    }
    return pages
}
const Pager = ({ page, pageSize, totalRecords, onPage, onPageSize, disabled }) => {
    const pageCount = Math.max(1, Math.ceil(totalRecords / pageSize))
    const first = totalRecords === 0 ? 0 : (page - 1) * pageSize + 1
    const last = Math.min(page * pageSize, totalRecords)

    return (
        <div className={Style.pager}>
            <span className={Style.pagerInfo}>
                Showing <strong>{first}–{last}</strong> of <strong>{totalRecords.toLocaleString()}</strong>
            </span>
            <label className={Style.pageSize}>
                Rows
                <select value={pageSize} disabled={disabled} onChange={(event) => onPageSize(Number(event.target.value))}>
                    {PAGE_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
                </select>
            </label>
            {pageCount > 1 ? (
                <nav className={Style.pages} aria-label="Pagination">
                    <button type="button" className={Style.pageButton} disabled={disabled || page === 1} onClick={() => onPage(page - 1)} aria-label="Previous page">
                        <i className="uil-angle-left" aria-hidden="true" />
                    </button>
                    {pageWindow(page, pageCount).map((p, index) =>
                        p === null ? (
                            <span key={`gap-${index}`} className={Style.pageGap}>…</span>
                        ) : (
                            <button
                                key={p}
                                type="button"
                                className={[Style.pageButton, p === page ? Style.pageButtonActive : ''].join(' ')}
                                aria-current={p === page ? 'page' : undefined}
                                disabled={disabled}
                                onClick={() => onPage(p)}
                            >
                                {p}
                            </button>
                        )
                    )}
                    <button type="button" className={Style.pageButton} disabled={disabled || page === pageCount} onClick={() => onPage(page + 1)} aria-label="Next page">
                        <i className="uil-angle-right" aria-hidden="true" />
                    </button>
                </nav>
            ) : null}
        </div>
    )
}

export default Pager
